import { render, staticRenderFns } from "./domainmgt.vue?vue&type=template&id=f8ffa5c8"
import script from "./domainmgt.vue?vue&type=script&lang=js"
export * from "./domainmgt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports